export default __webpack_public_path__ + "static/media/slide1.518723d3.jpg";